// extracted by mini-css-extract-plugin
export default {"produto":"ProdutoCardCarrinho_produto__ViJSN","infoProduto":"ProdutoCardCarrinho_infoProduto__DrmZs"};